import { View } from "@-/com.npmjs.react-native";
import { HaniSpeechCompanion } from "@-/dev.improve.haniverse.components.ui.hani-sheet-perch";
import type { ReactNode } from "react";

/** The authored copy remains ordinary accessible text; only the bubble tail is decorative. */
export function OnboardingSpeechBubble({
  children,
  tail = "top",
  testID,
}: {
  children: ReactNode;
  tail?: "left" | "top";
  testID: string;
}) {
  return (
    <View
      className="relative gap-3 rounded-xs border-2 border-border bg-surface p-4"
      testID={testID}
    >
      <View
        accessibilityElementsHidden
        className={
          tail === "top"
            ? "absolute -top-2 left-1/2 size-4 rotate-45 border-t-2 border-l-2 border-border bg-surface"
            : "absolute top-5 -left-2 size-4 rotate-45 border-b-2 border-l-2 border-border bg-surface"
        }
        importantForAccessibility="no-hide-descendants"
        pointerEvents="none"
      />
      {children}
    </View>
  );
}

export function OnboardingGuideMessage({
  children,
  testID,
}: {
  children: ReactNode;
  testID: string;
}) {
  return (
    <View className="flex-row items-start gap-3">
      <View className="pt-3">
        <HaniSpeechCompanion />
      </View>
      <View className="min-w-0 flex-1">
        <OnboardingSpeechBubble tail="left" testID={testID}>
          {children}
        </OnboardingSpeechBubble>
      </View>
    </View>
  );
}
